// store.js
import { createStore } from 'vuex';

const store = createStore({
    state: {
        locale: "zh",
        isLocaleLoaded: false, // 语言包是否加载完成
    },
    mutations: {
        //this.$store.commit('setlocale', 'new value');
        setLocale(state,value) {
            state.locale=value;
            sessionStorage.setItem('vuex-data-locale', JSON.stringify(value));
            // localStorage.setItem('vuex-data-locale', JSON.stringify(value));
        },
        setLocaleLoaded(state, value) {
            state.isLocaleLoaded = value;
        },
    },
    actions: {
        // this.$store.dispatch('setlocale', 'new value');
        setLocale({ commit },value) {
            commit('setLang',value);
        },
        loadData({ commit }) {
            // const data = localStorage.getItem('vuex-data-locale');
            const data = sessionStorage.getItem('vuex-data-locale');
            if (data) {
                commit('setLocale', JSON.parse(data));
            }
        }
    },
    //this.$store.state.locale
    getters: {
        getLang: (state) => state.locale
    }
});
// 在应用启动时加载数据
store.dispatch('loadData');
export {
    store
}